import { render, staticRenderFns } from "./noDocumentsIcon.vue?vue&type=template&id=3b586933&scoped=true&"
import script from "./noDocumentsIcon.vue?vue&type=script&lang=js&"
export * from "./noDocumentsIcon.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "3b586933",
  null
  ,true
)

export default component.exports